const getFileError = file => {
    switch (file.error) {
        default: return file.error;
        case 'network': return 'Your internet connection seems to be down. Please try again.';
        case 'timeout': return 'The upload was unsuccessful because your internet connection timed out. Please try again.';
        case 'server': return 'There is an error on our side. Please try again, and if it\'s unsuccessful, contact us.';
    }
};

export default getFileError;